export default __webpack_public_path__ + "static/media/dropBox.71da1b2a.svg";